var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCollapsed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.162,
    height: 50.297,
    viewBox: "0 0 53.162 50.297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(22.123 9.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    d: "M0,0H12.057a0,0,0,0,1,0,0V19.607a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,19.607V0A0,0,0,0,1,0,0Z",
    transform: "translate(31.039 18.127) rotate(135)",
    fill: "#27bdd8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    d: "M0,0H12.057a0,0,0,0,1,0,0V25.81a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,25.81V0A0,0,0,0,1,0,0Z",
    transform: "translate(22.513 9.66) rotate(45)",
    fill: "#2ddfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    d: "M16314.922-1653.2l-8.436,8.5-.83-.829Z",
    transform: "translate(-16292.448 1662.86)",
    opacity: 0.333
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    d: "M0,0H12.057a0,0,0,0,1,0,0V19.607a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,19.607V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 22.572) rotate(-45)",
    fill: "#025186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    d: "M0,0H12.057a0,0,0,0,1,0,0V25.81a6.028,6.028,0,0,1-6.028,6.028h0A6.028,6.028,0,0,1,0,25.81V0A0,0,0,0,1,0,0Z",
    transform: "translate(8.525 31.039) rotate(-135)",
    fill: "#0058ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    d: "M16305.656-1644.7l8.438-8.5.828.829Z",
    transform: "translate(-16297.014 1675.736)",
    opacity: 0.333
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollapsed);
export default __webpack_public_path__ + "static/media/logo_collapsed.90861f6e3f8f1060d6b33273466d74be.svg";
export { ForwardRef as ReactComponent };